import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '../request';
import { getBase64, isImage, isVideo, isPDF } from '@/views/claim/demageManage/utils';
const MAX_SIZE = 50; // MB
const MAX_VIDEO_SIZE = 300; // MB

export default {
  props: {
    formDataArray: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  data() {
    return {
      ListData: [],
      //存储上上传的数据列表
      isModalVisible: false,
      //
      action: uploadFile
    };
  },
  mounted() {
    console.log('获取上传', this.formDataArray);
  },
  computed: {},
  methods: {
    // 模板预览打开
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    // 文件上传逻辑
    clickPlusTWO() {
      // 文件的类型的数据
      if (this.formDataArray.fileFormat.length == 0) {
        this.$message.error(this.$t('请选择文件格式'));
        return;
      }
    },
    changeUploadTwo({
      file,
      fileList
    }) {
      const isVideoFile = isVideo(file.name);
      const maxSize = isVideoFile ? MAX_VIDEO_SIZE : MAX_SIZE;
      if (!this.isFileSizeValid(file, maxSize)) {
        const errorMessage = this.$t(isVideoFile ? '视频最大不超300M' : '文件最大不超50M');
        this.$message.error(errorMessage);
        return;
      }
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      // 文件类型
      if (!this.formDataArray.fileFormat.includes(fileType)) {
        this.$message.error(this.$t('文件格式错误'));
        return;
      }
      // 文件列表
      this.formDataArray.templateUrl = fileList.map(item => {
        if (item.response && item.response.code === 200 && item.status === 'done') {
          item.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(item.response.data).fileTempUrl : item.response.data.fileTempUrl;
          // 将文件URL添加到templateUrl变量中
          // this.formDataArray.templateUrl += item.url + ',';
        }
        return item;
      });
      // 移除最后一个逗号
      // this.formDataArray.templateUrl = this.formDataArray.templateUrl.slice(0, -1);
    },
    isFileSizeValid(file, maxSize) {
      return file.size / 1024 / 1024 < maxSize;
    },
    // 附件上传新建
    beforeUpload(file) {
      // 检查文件格式是否符合要求
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!this.formDataArray.fileFormat.includes(fileExtension)) {
        this.$message.error(`文件格式不正确，请选择 ${this.formDataArray.fileFormat.join(', ')} 格式的文件`);
        return false;
      }

      // 检查文件大小是否符合要求
      const maxSizeInBytes = this.formDataArray.fileSize.size * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        this.$message.error(`文件大小超过限制，请选择小于 ${this.formDataArray.fileSize.size}${this.formDataArray.fileSize.type} 的文件`);
        return false;
      }
      return true;
    }
  }
};